(function($) {
    var validationOptions = {
        rules: {
            email: {
                required: true,
                myEmail: true
            },
            name: {
                required: true
            },
            html_content: {
                required: true
            }
        },
        messages: {
            email: {
                required: "Adres e-mail jest wymagany",
                myEmail: "Wymagany jest poprawny adres e-mail"
            },
            name: {
                required: "To pole jest wymagane"
            },
            html_content: {
                required: "Treść komentarza jest wymagana"
            }
        }
    };

    $.fn.commentPlugin = function(options) {
        var randomNumber = Math.floor(100000 + Math.random() * 900000);
        var commentData = {
            document_data: {
                author: {
                    name: "",
                    email: ""
                },
                html_content: ""
            }
        };
        var settings = {};
        settings = $.extend(settings, options);
        var html =
            '<form id="addCommentForm"><input type="hidden" id="captchaResponse' +
            randomNumber +
            '" name="g-recaptcha-response" value="" ><textarea name="html_content" class="bg-white f6 w-100 ba b--moon-gray pa2" style="height: 78px;" id="commentContent"></textarea><div class="mt3 mb3"><div class="f6 mb2">Podpis:</div><input name="name" type="text" class="f6 w-100 ba b--moon-gray pa2"></div><div class="mb3"><div class="f6 mb2">Twój adres e-mail:</div><input name="email" type="text" class="f6 w-100 ba b--moon-gray pa2"></div><div class="mt3 pt1 mb3"><div id="recaptchaBox' +
            randomNumber +
            '" class="g-recaptcha dib"></div><div id="recaptcha_error" class="mt1 red dn" initial="false" data-toggle-class-value="" data-toggle-class-true="" data-toggle-class-false="dn"><span class="mr1"><svg xmlns="http://www.w3.org/2000/svg" fill="#000000" height="24" viewBox="0 0 24 24" width="24" class="injected-svg" style="width:16px;height:16px;margin-left:-2px;" data-src="/img/icons/error.svg"><path d="M0 0h24v24H0z" fill="none"></path><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"></path></svg></span> Aby opublikować komentarz musisz zaznaczyć powyższe pole</div></div><div class="flex justify-between"><a href="" id="submitBtn" class="flex relative no-underline lh-solid shrink-0 ba bw1 f5  b--orange br5 white bg-orange cursor-pointer bg-near-black-hover b--near-black-hover "><span class="w-100 flex items-center justify-center pv2 ph3 tc tl-ns "><span class="">Dodaj komentarz</span></span></a><a href="" class="flex relative no-underline lh-solid shrink-0 ba bw1 f5   br5 dark-gray  cursor-pointer bg-dark-gray-hover b--dark-gray-hover white-hover " id="cancelBtn"><span class="w-100 flex items-center justify-center pv2 ph3 tc tl-ns "><span class="">Anuluj</span></span></a></form>';
        if (options.title) {
            html = options.title + html;
        }
        if (options.withBorder) {
            html =
                '<div class="f7 pt2 pl4"><div class="ba b--light-gray pa3"><div class="f6 mb2">' +
                html +
                "</div></div></div>";
        } else {
            html = '<div class="bb b--light-gray pa3"><div class="f6 mb2">' + html + "</div></div>";
        }
        return this.each(function(index) {
            var $this = $(this);
            $this.on("click.commentBox", function(e) {
                e.preventDefault();
                var $after = $(html).insertAfter($this);
                $this.hide();
                var $form;
                $after.find("#addCommentForm").each(function() {
                    $form = $(this);
                    $form.validate(validationOptions);
                });
                $after.find("#commentContent").each(function() {
                    $(this).focus();
                });
                if (grecaptcha) {
                    grecaptcha.render("recaptchaBox" + randomNumber, {
                        sitekey: options.captchaKey,
                        callback: "correctCaptcha"
                    });
                }
                $after.find("#cancelBtn").each(function() {
                    $(this).on("click", function(e) {
                        e.preventDefault();
                        $this.show();
                        $after.remove();
                    });
                });
                $after.find("#submitBtn").each(function() {
                    $(this).on("click", function(e) {
                        e.preventDefault();
                        if ($form.valid()) {
                            var formData = $form.serializeArray();
                            for (var i = 0; i < formData.length; i++) {
                                var item = formData[i];
                                switch (item.name) {
                                    case "name":
                                        commentData.document_data.author.name = item.value;
                                        break;
                                    case "html_content":
                                        commentData.document_data.html_content = item.value;
                                        break;
                                    case "email":
                                        commentData.document_data.author.email = item.value;
                                        break;
                                    case "g-recaptcha-response":
                                        commentData["g-recaptcha-response"] = item.value;
                                        break;
                                    default:
                                        break;
                                }
                            }
                            $.ajax({
                                type: "POST",
                                url: options.url,
                                data: JSON.stringify(commentData),
                                dataType: "json",
                                contentType: "application/json",
                                xhrFields: {
                                    withCredentials: true
                                },
                                success: function(response) {
                                    if (grecaptcha) {
                                        grecaptcha.reset();
                                    }
                                    if (response.message) {
                                        alert(response.message);
                                    } else {
                                        var $newComment;
                                        if (options.withBorder) {
                                            var $commentTemplate = $this
                                                .closest("#subcommentsContainer")
                                                .find("#emptysubComment");
                                            $newComment = $commentTemplate.clone();
                                            $newComment.insertAfter($commentTemplate);
                                        } else {
                                            var $commentTemplate = $this
                                                .closest("#commentsContainer")
                                                .find("#emptyComment");
                                            $newComment = $commentTemplate.clone();
                                            $newComment.insertAfter($commentTemplate);
                                        }
                                        $newComment.show();
                                        $commentTemplate.attr("id", "newComment");
                                        $newComment.find("#name").each(function() {
                                            $(this).html(commentData.document_data.author.name);
                                        });
                                        $newComment.find("#contentLong").each(function() {
                                            $(this).html(commentData.document_data.html_content);
                                        });
                                    }
                                    return null;
                                },
                                error: function(jqXHR, textStatus, errorThrown) {
                                    alert(textStatus);
                                    if (grecaptcha) {
                                        grecaptcha.reset();
                                    }
                                    return null;
                                }
                            });
                        }
                    });
                });
            });
            return $this;
        });
    };

    function correctCaptcha(response) {
        $("#captchaResponse" + options.docId)
            .val(response)
            .change();
    }
})(jQuery);
